import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check, ShieldCheck, Headphones } from 'lucide-react';
export function CtaSection() {
  return <section id="pricing" className="py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-charcoal-dark to-charcoal relative" data-id="element-39">
      <div className="max-w-3xl mx-auto text-center" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-8" data-id="element-41">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight" data-id="element-42">
            Dentro de 15 días podés estar vendiendo focaccias…{' '}
            <br className="hidden sm:block" data-id="element-43" />
            <span className="text-gold italic font-normal" data-id="element-44">
              o seguir pensando "algún día empiezo"
            </span>
          </h2>

          <div className="bg-warmBrown border border-gold/30 rounded-3xl p-8 sm:p-12 relative overflow-hidden shadow-[0_0_50px_rgba(212,168,83,0.15)]" data-id="element-45">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-32 bg-gold/20 blur-[60px] pointer-events-none" data-id="element-46" />

            <img src="https://cdn.magicpatterns.com/uploads/jdVrssbjQjGtppE5kJgSN1/ChatGPT_Image_4_abr_2026,_11_07_59_p.m..png" alt="Pack completo" className="max-w-full sm:max-w-md mx-auto mb-8 drop-shadow-[0_20px_30px_rgba(0,0,0,0.5)]" data-id="element-47" />

            <p className="text-sm font-semibold text-red-400 flex items-center justify-center gap-2 mb-2" data-id="element-48">
              <span data-id="element-49">🔥</span> Acceso hoy por
            </p>

            <div className="flex items-baseline justify-center gap-3 mb-2" data-id="element-50">
              <span className="text-5xl sm:text-7xl font-bold text-gold tracking-tight" data-id="element-51">
                $19.990
              </span>
              <span className="text-xl text-gold/80 font-medium" data-id="element-52">ARS</span>
            </div>
            <p className="text-cream-muted/50 line-through mb-8" data-id="element-53">
              Antes $39.980
            </p>

            <motion.a href="https://lacocinaquevende.shop/cart/53378602205457:1" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full sm:w-auto min-w-[300px] group relative inline-flex items-center justify-center gap-3 px-8 py-5 text-xl font-bold text-charcoal bg-gold hover:bg-gold-light rounded-full overflow-hidden transition-all duration-300 shadow-[0_0_40px_rgba(212,168,83,0.4)] hover:shadow-[0_0_60px_rgba(212,168,83,0.6)] mb-8" data-id="element-54">
              <span className="relative z-10 flex items-center gap-2" data-id="element-55">
                Quiero empezar ahora → acceso inmediato
              </span>
              <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-56" />
            </motion.a>

            <p className="text-[13px] text-cream-muted/60 -mt-4 mb-2" data-id="element-57">
              En menos de 2 minutos recibís todo en tu correo.
            </p>
            <p className="text-xs text-cream-muted/50 mb-6" data-id="element-58">
              ✓ 7 días de garantía — si no te convence, te devolvemos el dinero
              sin preguntas.
            </p>

            {/* Payment methods */}
            <div className="flex flex-col items-center gap-4 mb-8" data-id="element-59">
              <img src="https://cdn.magicpatterns.com/uploads/skrFUyqtUJTwMzj9hzFaaf/descarga_(2).png" alt="Mercado Pago" className="w-[140px] h-auto" data-id="element-60" />
              <p className="text-xs text-cream-muted/70" data-id="element-61">
                Hasta 3 cuotas sin interés con tarjeta
              </p>
              <div className="flex items-center gap-3" data-id="element-62">
                <span className="bg-[#1a1f71] text-white px-3 py-1.5 rounded text-xs font-bold italic" data-id="element-63">
                  VISA
                </span>
                <span className="bg-[#eb001b] text-white px-3 py-1.5 rounded text-xs font-bold italic" data-id="element-64">
                  mastercard
                </span>
              </div>
              <div className="flex items-center gap-2 text-sm text-cream-muted/70" data-id="element-65">
                <ShieldCheck className="w-4 h-4 text-gold" data-id="element-66" />
                <span data-id="element-67">Pago 100% seguro y acceso inmediato</span>
              </div>
            </div>

            {/* Trust badges */}
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-cream-muted/80 border-t border-white/10 pt-6" data-id="element-68">
              <span className="flex items-center gap-2" data-id="element-69">
                <Check className="w-4 h-4 text-gold" strokeWidth={3} data-id="element-70" />
                Acceso inmediato
              </span>
              <span className="flex items-center gap-2" data-id="element-71">
                <ShieldCheck className="w-4 h-4 text-gold" data-id="element-72" />
                Pago seguro
              </span>
              <span className="flex items-center gap-2" data-id="element-73">
                <Headphones className="w-4 h-4 text-gold" data-id="element-74" />
                Soporte incluido
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}